export function originHeaders() {
  return [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      sortable: false,
      show: true,
      width: '4%'
    },
    {
      text: 'Học sinh',
      value: 'name',
      align: 'left',
      sortable: false,
      show: true,
      width: '24%'
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      align: 'left',
      sortable: false,
      show: true,
      width: '12%'
    },
    {
      text: 'Lớp',
      value: 'currentClass',
      align: 'left',
      sortable: false,
      show: true,
      width: '8%'
    },
    {
      text: 'Tổng số tiền thu',
      value: 'totalAmount',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%'
    },
    {
      text: 'Đối soát lúc',
      value: 'doneAt',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%'
    }
  ]
}
export const headerExcel = [
  {
    text: 'Tên học sinh',
    value: 'name'
  },
  {
    text: 'Mã số',
    value: 'code'
  },
  {
    text: 'Lớp',
    value: 'class'
  },
  {
    text: 'Ghi chú',
    value: 'notes'
  },
  {
    text: 'Tổng số tiền thu',
    value: 'totalAmount'
  }
]
